// extracted by mini-css-extract-plugin
export default {"board":"KeyBoard_board__3GKrw","row1":"KeyBoard_row1__U5LgY","row2":"KeyBoard_row2__dHpd6"};